import React, { useState } from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);
  return <div className="fixed bottom-6 right-6 z-50" data-id="element-148">
      {/* Tooltip */}
      {showTooltip && <div className="absolute bottom-full right-0 mb-2 px-4 py-2 bg-white text-gray-900 text-sm font-medium rounded-lg shadow-lg whitespace-nowrap animate-[fadeIn_0.2s_ease-in-out]" data-id="element-149">
          Para dudas comunicarse con soporte
          <div className="absolute top-full right-4 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-white" data-id="element-150"></div>
        </div>}

      {/* WhatsApp Button */}
      <a href="https://wa.me/message/CMWGN4MINPN2I1" target="_blank" rel="noopener noreferrer" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} className="flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110" aria-label="Contactar por WhatsApp" data-id="element-151">
        <MessageCircleIcon className="w-7 h-7" data-id="element-152" />
      </a>
    </div>;
}